import { forwardRef } from 'react';

import { ArrowDownShortIcon, ArrowUpShortIcon } from '../../icons';
import { cn } from '../../utils';
import { RippleRoot } from '../RippleRoot';

interface StepperButtonProps
  extends Omit<React.ComponentProps<'button'>, 'children'> {
  stepperType: 'increase' | 'decrease';
}

export const StepperButton = forwardRef<HTMLButtonElement, StepperButtonProps>(
  ({ stepperType, onClick, disabled, ...props }, ref) => {
    const testId =
      stepperType === 'increase'
        ? 'increase-value-button'
        : 'decrease-value-button';

    return (
      <button
        type="button"
        id={testId}
        data-testid={testId}
        aria-label={
          stepperType === 'increase' ? 'Increase value' : 'Decrease value'
        }
        className={cn(
          'relative overflow-hidden flex items-center justify-center flex-1 w-10 rounded-none focus-visible:relative ',
          stepperType === 'increase' ? 'rounded-tr-sm' : 'rounded-br-sm',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
        )}
        onClick={onClick}
        {...props}
        disabled={disabled}
        ref={ref}
      >
        {stepperType === 'increase' ? (
          <ArrowUpShortIcon size="xs" />
        ) : (
          <ArrowDownShortIcon size="xs" />
        )}
        <RippleRoot
          className="bg-black"
          pulseDuration={0.7}
          pulseOpacity={0.5}
        />
      </button>
    );
  },
);
